import { Component, Input , OnInit} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AntennaModel } from 'src/app/models/antennaModel';
import { coverageAssessmentToolDTOModal, coverageDTO } from 'src/app/models/coverageDTO';
import { NavaidModel } from 'src/app/models/navaid';
import { CalculationsService } from 'src/app/services/calculations.service';
import { ModalConfirmationService } from 'src/app/services/modal-confirmation.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { SelectAntennaPatternService } from 'src/app/services/select-antenna-pattern.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ValidationModalService } from 'src/app/services/validation-modal.service';

@Component({
  selector: 'app-navaid-antenna-model-association',
  templateUrl: './navaid-antenna-model-association.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class NavaidAntennaModelAssociationComponent {

  @Input()
  coverageDTO: coverageDTO;

  @Input()
  calculationType: String;

  antennaModels: AntennaModel[];


  constructor(public bsModalRef : BsModalRef,
    public bsModalService: BsModalService,
    public antennaPatternService: SelectAntennaPatternService,
    private modalService : ModalControlService,
    private validationModalService: ValidationModalService,
    private modalConfirmation: ModalConfirmationService,
    private utilsService: UtilsService,
    private calculationService: CalculationsService) {


  }

  async ngOnInit(){
    this.antennaModels = await this.antennaPatternService.getAllAntennaModels();
    for (const nav of this.coverageDTO.navaids){
      if (nav.antennaModelName != null){
        const antennaModelExists: boolean
        = this.antennaModels
        .findIndex(a => a.modelName == nav.antennaModelName) != -1;

        if (!antennaModelExists){
          nav.antennaModelName = null;
        }
      }

      if (nav.antennaModelName == null){
        if (nav.type == "DME" || nav.type == "VOR_DME"){
          nav.antennaModelName = this.antennaModels[0].modelName;
        } else if (nav.type == "TACAN" || nav.type == "VORTAC"){
          nav.antennaModelName = this.antennaModels[1].modelName;
        }
      }

    }
  }


  proceedWithCalculation(){
    if (!this.allSelected()){
      this.modalService.showMesssageModal("Antenna Model Selection", "Please select an Antenna Model for each navaid");
      return;
    }
    this.bsModalRef.hide();
    if (this.calculationType == "Coverage"){
      this.calculationService.calculateCoverage(this.coverageDTO);
    }else {
      this.calculationService.calculateCumulativeCoverage(this.coverageDTO);
    }

  }

  allSelected(): boolean{
    for (const navaid of this.coverageDTO.navaids){
      if (navaid.antennaModelName == null){
        return false;
      }
    }
    return true;
  }





}
